import { ElementRef, EventEmitter } from '@angular/core';
import { config } from '../../../../config/config';
import { ImageService } from '../../../services/image.service';
import { bindFunctionsToThis } from '../../extensions';
import { GlobalEventEmitter } from "../../services/global.event.emitter";
var FacebookLoginButtonComponent = /** @class */ (function () {
    function FacebookLoginButtonComponent(imageService) {
        this.imageService = imageService;
        this.fbLogo = config.fbLogo;
        this.customize = false;
        this.isQuadrate = false;
        this.isSmallest = false;
        this.onLoginStatusChanged = new EventEmitter();
        bindFunctionsToThis(this);
        this.fbLogo = this.imageService.imageSourceUrl(this.fbLogo);
        this.syncFacebookStatus();
        FacebookLoginButtonComponent.isExSmallMobile = window.innerWidth < config.exSmallphoneSizeWidth;
        FacebookLoginButtonComponent.isMobile = window.innerWidth < config.phoneSizeWidth && !FacebookLoginButtonComponent.isExSmallMobile;
        FacebookLoginButtonComponent.isSmallPC = window.innerWidth < config.smallPCSizeWidth && !FacebookLoginButtonComponent.isMobile;
    }
    Object.defineProperty(FacebookLoginButtonComponent.prototype, "isUserLoggedWithFacebook", {
        get: function () {
            return FacebookLoginButtonComponent.isUserLoggedWithFacebook;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacebookLoginButtonComponent.prototype, "profilePicture", {
        get: function () {
            return FacebookLoginButtonComponent.profilePicture;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacebookLoginButtonComponent.prototype, "isSmallPC", {
        get: function () {
            return FacebookLoginButtonComponent.isSmallPC;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacebookLoginButtonComponent.prototype, "isMobile", {
        get: function () {
            return FacebookLoginButtonComponent.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FacebookLoginButtonComponent.prototype, "isExSmallMobile", {
        get: function () {
            return FacebookLoginButtonComponent.isExSmallMobile;
        },
        enumerable: true,
        configurable: true
    });
    FacebookLoginButtonComponent.prototype.login = function () {
        var _this = this;
        FB.login(function (response) {
            if (!response || !response.authResponse) {
                return;
            }
            _this.syncFacebookStatus();
        }, { scope: config.facebook.graphApi.scope });
    };
    FacebookLoginButtonComponent.prototype.logout = function () {
        var _this = this;
        FB.logout(function () {
            _this.syncFacebookStatus();
        });
    };
    FacebookLoginButtonComponent.prototype.syncFacebookStatus = function () {
        var _this = this;
        try {
            FB.getLoginStatus(function (response) {
                if (response.status === 'connected') {
                    FacebookLoginButtonComponent.isUserLoggedWithFacebook = true;
                    FacebookLoginButtonComponent.authResponse = response;
                    FacebookLoginButtonComponent.userAccessToken = response.authResponse.accessToken;
                    FacebookLoginButtonComponent.profilePicture = config.facebook.graphApi.profilePicture
                        .replace('${userId}', response.authResponse.userID);
                    setTimeout(function () {
                        if (_this.profileImg) {
                            _this.profileImg.nativeElement.style.display = 'block';
                        }
                        _this.onLoginStatusChanged.emit(true);
                        // for some components (such as the PlaceDetailsModal) which cannot get the event, it uses this global event emitter to emit the login status
                        GlobalEventEmitter.emit('onFBLoginStatusChanged');
                        console.log('emit onFBLoginStatusChanged true');
                    });
                }
                else {
                    FacebookLoginButtonComponent.isUserLoggedWithFacebook = false;
                    FacebookLoginButtonComponent.authResponse = null;
                    FacebookLoginButtonComponent.userAccessToken = null;
                    FacebookLoginButtonComponent.profilePicture = null;
                    setTimeout(function () {
                        if (_this.profileImg) {
                            _this.profileImg.nativeElement.style.display = 'none';
                        }
                        _this.onLoginStatusChanged.emit(false);
                        // for some components (such as the PlaceDetailsModal) which cannot get the event, it uses this global event emitter to emit the login status
                        GlobalEventEmitter.emit('onFBLoginStatusChanged');
                        console.log('emit onFBLoginStatusChanged false');
                    });
                }
            });
        }
        catch (e) {
            console.warn(e);
        }
    };
    return FacebookLoginButtonComponent;
}());
export { FacebookLoginButtonComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/facebook.login.button/facebook.login.button.component.ts.pre-build-optimizer.js